/* ------------------------------------------------------------------------ */
/*		File: cmpSitemap.tsx                                                */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICard } from "./cmpSitemap.d";
import "./cmpSitemap.css"
import { Link } from "react-router-dom";

/* ------------------------------------------------------------------------ */

const Sitemap: React.FC<ICard> = ({card, onClick}) => {

    return (
        <div className="card_sitemap">
            <div className="card_sitemap_label">Sitemap</div>
                <div className="card_sitemap_content scrollbar-thin scrollbar-thumb-rounded">
                    <div className="card_sitemap_content_row">
                        {card !== null && card?.map((item, index) => (
                            <>
                                {item.show && (
                                    <div className="card_sitemap_content_group">
                                        <div className="card_sitemap_level_0">
                                            <Link 
                                                key={`dfLink0-${index}`} 
                                                className="card_sitemap_row_links" 
                                                to={item!.navigateTo || "/"}
                                                onClick={onClick}
                                            >
                                                <div className="card_sitemap_square_blue"></div>
                                                {item?.label}
                                            </Link>  
                                        </div>

                                        {item.submenus !== null && item.submenus?.map((item, index) => (
                                            <div className="card_sitemap_level_1">
                                                <Link 
                                                    key={`dfLink1-${index}`} 
                                                    className="card_sitemap_row_links" 
                                                    to={item!.navigateTo || "/"}
                                                    onClick={onClick}
                                                >
                                                    <div className="card_sitemap_square_yellow"></div>
                                                    {item?.label}
                                                </Link>  
                                            </div>
                                        ))}                      
                                    </div>
                                )}
                            </>
                        ))}
                    </div>
                </div>
        </div>
    );
  };
  
  export default Sitemap;